import IComp from '@/models/Comp';
import BaseApiService from '../BaseApiService';
import WebEnvConfig from '@/models/WebEnvConfig';
import LocalCompRequest from '@/models/requests/LocalCompRequest';
import IFeedData from '@/models/comp/IFeedData';
import IManualComp from '@/models/comp/IManualComp';
import ICompAddress from '@/models/CompAddress';
import CompAddressUtils from '@/models/comp/CompAddressUtils';
import IServiceHelper from '../IServiceHelper';
import ServiceHelperFactory from './ServiceHelperFactory';

export default class DataDiscrepancyService extends BaseApiService {
    constructor(webEnvConfig: WebEnvConfig) {
        super(webEnvConfig.urls?.quickSourceApi ?? '');
    }

    getServiceHelper(): IServiceHelper {
        return ServiceHelperFactory.getHelper();
    }

    async getCompAddresses(almCompId: string): Promise<IComp[]> {
        let result: IComp[] = [];
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        const data = JSON.stringify(almCompId);

        const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/CompAddressAndFormFillerData', data);
        if (response.data) {
            result = response.data;
        }
        return result;
    }

    async getDBSourceData(localCompRequest: LocalCompRequest): Promise<IFeedData | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/LocalBestComp', localCompRequest);
            if (response.status === 200) {
                const result: IFeedData = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(localCompRequest.address);
            console.log(`DataDiscrepancyService.getDBSourceData(), Error[${errorDescription}] on address[${addressDescription}], comps Guid[${localCompRequest.compsGuid}]`);
        }
        return null;
    }

    async getMLSToken(): Promise<string | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const response = await this.axiosInstance.get('v1.0/DataDiscrepancy/MlsMapperToken');
            if (response.status === 200) {
                const result: string = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            console.log(`DataDiscrepancyService.getMLSToken(), Error[${errorDescription}]`);
        }
        return null;
    }

    async scrubAddress(payload: IManualComp): Promise<ICompAddress> {
        let result = {};
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();

        const data = JSON.stringify(payload);
        const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/ScrubAddress', data);
        if (response.data) {
            result = response.data;
        }
        return result as ICompAddress;
    }

    async getDBSubComps(localCompRequest: LocalCompRequest): Promise<IFeedData[] | null> {
        this.addContentTypeJsonHeader();
        this.addAcceptJsonHeader();
        //this.setLogRequest(true);

        try {
            const data = JSON.stringify(localCompRequest);

            const response = await this.axiosInstance.post('v1.0/DataDiscrepancy/LocalComps', data);
            if (response.status === 200) {
                const result: IFeedData[] = response.data;
                return result;
            }
        } catch (error) {
            const errorDescription = this.getErrorDescription(error);
            const addressDescription = CompAddressUtils.getDescription(localCompRequest.address);
            console.log(`DataDiscrepancyService.getDBSubComps(), Error[${errorDescription}] on address[${addressDescription}], comps Guid[${localCompRequest.compsGuid}]`);
        }
        return null;
    }
}
